'use client';

export * from './clientLeagueTables.types';
export { default as ClientLeagueTables } from './clientLeagueTables.component';
